import { useDispatch, useSelector } from 'react-redux';
import { getConsultationClinic as getConsultationClinicAction } from 'Redux/modules/webChat/consult/actions';
import { useCallback } from 'react';

const useConsultationClinic = () => {
  const dispatch = useDispatch();

  const { consultationClinic } = useSelector(state => state.webChat.consults);

  const getConsultationClinic = useCallback(
    (doctorId, consultId) => dispatch(getConsultationClinicAction(doctorId, { consultId })),
    [dispatch],
  );

  return {
    consultationClinic,
    getConsultationClinic,
  };
};

export default useConsultationClinic;
